const getters = {
  token: state => state.user.token,
  cpr: state => state.user.cpr,
  roles: state => state.user.roles,
  status: state => state.user.status,
  online: state => state.user.online,
  model: state => state.user.model,
  channelTag: state => state.user.channelTag,
  yunpanSwitch:state => state.user.yunpanSwitch,
  telecomYunpanSwitch:state=>state.user.telecomYunpanSwitch,
  ltYunpanSwitch:state=>state.user.ltYunpanSwitch,
  isBindPhone:state=>state.user.isBindPhone,
  userChannelTag:state=>state.user.userChannelTag,
  rewardSwitch:state=>state.user.rewardSwitch,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js